// index.tsx ou index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/style/main.css';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from "./i18n/i18n";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ScaleProviderMobile } from "./contexts/ScaleContextMobile";
import { ScaleProviderDesktop } from "./contexts/ScaleContextDesktop";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./contexts/AuthContext";
import { UrlProvider } from "./contexts/UrlContext";
import { LanguageSelectionProvider } from "./contexts/LanguageSelectionContext";
import AppInsightsRouteTracker from "./components/telemetry/AppInsightsRouteTracker";
import { initializeAppInsights } from "./services/telemetry/appInsights";

initializeAppInsights();

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<I18nextProvider i18n={i18n}>
				<LanguageSelectionProvider>
				<UrlProvider>
					<ScaleProviderDesktop>
						<ScaleProviderMobile>
							<AuthProvider>
								<ToastContainer/>
								<AppInsightsRouteTracker/>
								<App/>
							</AuthProvider>
						</ScaleProviderMobile>
					</ScaleProviderDesktop>
				</UrlProvider>
				</LanguageSelectionProvider>
			</I18nextProvider>
		</BrowserRouter>
	</React.StrictMode>
);
